import { appClient } from '@/lib/appwrite/appClient';
import { APP_COLLECTIONS, AppCategory } from '@polybank/shared';
import { ID } from 'appwrite';

class CategoriesService {
  async createCategory(
    data: Pick<AppCategory, 'name' | 'color'>
  ): Promise<AppCategory> {
    return appClient.tables.typed.createRow(
      APP_COLLECTIONS.CATEGORIES,
      ID.unique(),
      data
    );
  }

  async upsertCategory(
    category: AppCategory,
    id?: string
  ): Promise<AppCategory> {
    return appClient.tables.typed.upsertRow(
      APP_COLLECTIONS.CATEGORIES,
      id ?? ID.unique(),
      category
    );
  }
}

export const categoriesService = new CategoriesService();
